module.exports = __webpack_public_path__ + "media/images/forms-icons/checkbox-icon-hover-4b8c9ac3f0b927ef7ae2d2e2509973be.svg";